/* Imports */
import scrollama from "scrollama"; // intersection observer library

// Local
import DotChart from './DotChart/DotChart'
import SlideChart from './SlideChart/SlideChart'
import PolarizationChart from './PolarizationChart/PolarizationChart'

import { CLASSES as C } from './../globals/constants'
import './style.scss';

export default class App {
  constructor(data, summaryData, polarizationData) {
    this.data = data;
    this.summaryData = summaryData
    this.polarizationData = polarizationData
  }

  init() {
    // helpful if we need to update from parent
    this.dotChart = new DotChart(this.data)
    this.dotChart.init()
    this.slideChart = new SlideChart(this.summaryData)
    this.slideChart.init()
    this.polarizationChart = new PolarizationChart(this.polarizationData)
    this.polarizationChart.init()
    this.cards = this.slideChart.cards
    this.PoleSlides = this.polarizationChart.slides
    this.PoleSlides.forEach((slide) => slide.init && slide.init())

    /* Instantiate Scrollama */
    const scroller = scrollama()
    // setup scrollama the instance, pass callback functions
    scroller
      .setup({
        step: `.${C.STEP}`,
        once: true // only animate once
      })
      .onStepEnter(({ index }) => {
        // Draw dotchart on scroll
        this.dotChart.draw_axis()
        this.dotChart.draw()

        // animate slide dots
        // get card currently scrolled into view
        // index - 1 to compensate for fact that one step item comes before the array of slides
        // so we only want to start grabbing cards when step index is 1 (not 0)
        const currentCard = this.cards && this.cards[index - 1]
        const currentSlides = currentCard?.slideArray // get array of slide instances inside each card
        currentSlides && currentSlides.forEach(slide => slide.draw && slide.draw()) // animate dots on each slide for current card
      })
  }
}
